<div>
    <h2 style="margin-bottom: 12px;">Objetivo de cobranza mensual</h2>
    
    <div class="chart-container">
        <p-chart height="300px" type="bar" [data]="data" [options]="options"></p-chart>
    </div>
</div>